import { Box, Center, Flex, FlexProps, ResponsiveValue, Spacer } from '@chakra-ui/react';
import Navigation from '../Navigation';
import { Logo } from '../Logo/index';

export interface TopBarProps {
    maxWidth?: number;
};

const TopBar = (props: TopBarProps) => {
    return(
        <Center w='100%' h='80px' bg='brand.black'>
            <Flex flex='1' maxW={ (props.maxWidth !== undefined && props.maxWidth) || 'unset' } bg='brand.black' color='brand.white'>
                <Center>
                    <Box>
                        <Logo />
                    </Box>
                </Center>
                <Spacer />
                <Center>
                    <Box>
                        <Navigation />
                    </Box>
                </Center>
            </Flex>
        </Center>
    );
};

export default TopBar;